import React from "react";

const StoreProductSkeleton = ({ compact = false }) => (
  <div className="flex flex-col h-full bg-white border border-gray-100 rounded-sm overflow-hidden animate-pulse">
    <div className="aspect-square bg-gray-200" />
    <div className={`space-y-2 ${compact ? "p-2" : "p-2.5"}`}>
      <div className="h-3 w-16 bg-gray-200 rounded" />
      <div className="h-3 w-full bg-gray-200 rounded" />
      <div className="h-3 w-4/5 max-w-[85%] bg-gray-200 rounded" />
      <div className="h-4 w-20 bg-gray-300 rounded mt-1" />
      <div className="flex gap-2">
        <div className="h-2.5 w-14 bg-gray-200 rounded" />
        <div className="h-2.5 w-8 bg-gray-200 rounded" />
      </div>
      <div className="pt-1">
        <div className="h-2.5 w-20 bg-gray-200 rounded" />
      </div>
    </div>
  </div>
);

export default StoreProductSkeleton;
